



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { PositivePaySetup } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SavePositivePaySetup extends Base {
  public PositivePaySetupFields: Array<VFields<any>> = [];
  public PositivePaySetupModel: PositivePaySetup = {
    id: '',
    bankAccountNumber: '',
    dmsBankAccountNumber: '',
  };

  public storeId: number = 0;
  public form: any = {};
  public positivePaySeupDetailId: string = '';

  public requestProgress: boolean = false;
  public userList: any[] = [];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'PositivePaySetupDetails' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.savePositivePaySetupDetails();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.positivePaySeupId) {
      this.positivePaySeupDetailId = this.$route.params.positivePaySeupId;
    }

    this.setPositivePaySetupDetailsFields();
    if (this.$route.params.storeId) {
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setPositivePaySetupDetailsFields(): void {
    this.PositivePaySetupFields = [
      {
        key: 'bankAccountNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Bank Account Number',
          loading: false,
          rules:[
            v => this.required('BankAccountNumber', v)
          ]
        },
      },
      {
        key: 'dmsBankAccountNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'DMS Bank Account Number',
          loading: false,
          rules:[
            v => this.required('DMSBankAccountNumber', v)
          ]
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.PositivePaySetupFields);
      const response = await storeService.getStore(this.storeId);
      const positiveSetup = response.storeJson.positivePaySetups.find(
        (m) => m.id == this.$route.params.positivePaySeupId
      );
      if (this.positivePaySeupDetailId) {
        this.PositivePaySetupModel.id = positiveSetup.id;
        this.PositivePaySetupModel.bankAccountNumber = positiveSetup.bankAccountNumber;
        this.PositivePaySetupModel.dmsBankAccountNumber = positiveSetup.dmsBankAccountNumber;
      }
    } finally {
      this.formlyHideSkeleton(this.PositivePaySetupFields);
    }
  }

  public validateTrunkDetails(): Vue & { validate: () => boolean } {
    return this.$refs.positivePaySetupForm as Vue & { validate: () => boolean };
  }

  public async savePositivePaySetupDetails(): Promise<void> {
    if(this.validateTrunkDetails().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.PositivePaySetupModel.id === '') {
          await storeService.savePositivePaySeupDetails(this.storeId, this.PositivePaySetupModel);
          this.showAlert(true, 'Account Details Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'PositivePaySetupDetails'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updatePostivePaySetupDetails(this.storeId, this.PositivePaySetupModel);
          this.showAlert(true, 'Account Details Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab:'PositivePaySetupDetails'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
